// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__n5xuA","slider":"Switch_slider__3MW7S","disabled":"Switch_disabled__1ZF76","round":"Switch_round__2Bp4L"};